/** Coupon / autocall / callable: % from first coupons-table row, then product coupon, then amount/notional. */
export const formatEventFooterPercent = (
  firstCouponAmountPct: number,
  amount: number,
  notional: number,
  couponPercent: number
): string => {
  const fmt = (value: number): string =>
    `${new Intl.NumberFormat('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 3 }).format(value)}%`;
  if (firstCouponAmountPct > 0) {
    return fmt(firstCouponAmountPct);
  }
  if (couponPercent > 0) {
    return fmt(couponPercent);
  }
  if (notional > 0 && amount > 0) {
    return fmt((amount / notional) * 100);
  }
  return '—';
};

export const formatEventMaturityAmount = (amount: number, currency: string): string => {
  if (!(amount > 0)) {
    return '—';
  }

  const formatted = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);

  const trimmedCurrency = currency?.trim();
  return trimmedCurrency ? `${formatted} ${trimmedCurrency}` : formatted;
};
